import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow?: string;
  title: string;
  description?: string;
  action?: { to: string; label: string };
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  action,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 border-b border-background-800 pb-5 sm:flex-row sm:items-end sm:justify-between">
      <div className="min-w-0">
        {eyebrow && (
          <p className="mb-2 flex items-center gap-2 font-label text-xs uppercase tracking-[0.26em] text-accent-500">
            <span className="h-px w-6 bg-accent-500/70"></span>
            {eyebrow}
          </p>
        )}
        <h2 className="text-xl font-semibold tracking-tight text-foreground-950 md:text-2xl">
          {title}
        </h2>
        {description && (
          <p className="mt-2 max-w-2xl text-sm leading-relaxed text-foreground-600">
            {description}
          </p>
        )}
      </div>
      {action && (
        <Link
          to={action.to}
          className="group inline-flex shrink-0 items-center gap-2 text-sm text-foreground-700 transition-colors hover:text-accent-400"
        >
          {action.label}
          <i
            className="ri-arrow-right-line transition-transform group-hover:translate-x-1"
            aria-hidden="true"
          ></i>
        </Link>
      )}
    </div>
  );
}